<div class="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outline" class="example-card">
                <mat-card-header>
                    <mat-card-title>Info-Eintrag bearbeiten </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="dataForm">
                    <div class="row imageContainer" *ngIf="this.dataForm.value?.image?.href">
                        <img src="{{this.dataForm.value?.image.href}}" alt="">
                    </div>
                    <div class="row" *ngIf="!uploadImage">
                        <div class="col-sm-12">
                            <div *ngFor="let p of imageProperties" class="centerVerticalAndHoritontal marginTop2Rem">
                                <button mat-raised-button color="primary" (click)="openImageGallery(p)">Bild
                                    auswählen</button>
                            </div>
                        </div>
                    </div>
                    <div class="row marginTop2Rem">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Typ:</mat-label>
                                <mat-select formControlName="type">
                                    <mat-option *ngFor="let sortOption of newsType" [value]="sortOption.value"
                                        [disabled]="sortOption.state" (click)="changeForm()">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>
                                    Typ <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Überschrift:</mat-label>
                                <input matInput type="text" formControlName="title">
                                <mat-error>
                                    Überschrift <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Status:</mat-label>
                                <mat-select formControlName="state">
                                    <mat-option *ngFor="let sortOption of states" [value]="sortOption.value"
                                        [disabled]="sortOption.state">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>
                                    Status <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Anzeigen für:</mat-label>
                                <mat-select formControlName="visibility">
                                    <mat-option *ngFor="let sortOption of visibilityType" [value]="sortOption.value"
                                        [disabled]="sortOption.state">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>
                                    Anzeigen für <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editNewsItem()">Änderungen speichern </button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outline" class="example-card">
                <mat-card-header>
                    <mat-card-title>Veranstaltungsdetails</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="detailsForm">
                    <div class="row" *ngIf="this.dataForm.value.type == 'APPOINTMENT'">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Straße:</mat-label>
                                <input matInput type="text" formControlName="street">
                                <mat-error>
                                    Straße <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="this.dataForm.value.type == 'APPOINTMENT'">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>PLZ:</mat-label>
                                <input matInput type="text" formControlName="postcode">
                                <mat-error>
                                    PLZ <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Ort:</mat-label>
                                <input matInput type="text" formControlName="city">
                                <mat-error>
                                    Ort <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Veröffentlicht am:</mat-label>
                                <input matInput type="date" formControlName="publishedDate">
                                <mat-error>
                                    Veröffentlichungsdatum <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editNewsItem()">Änderungen speichern </button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

    <div class="row marginTop2Rem marginBottom2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outline" class="example-card">
                <mat-card-header>
                    <mat-card-title>Beschreibung</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="descriptionForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Unterzeile / Kurzbeschreibung:</mat-label>
                                <textarea formControlName="description" matInput rows="4" cols="50"></textarea>
                                <mat-error>
                                    Kurzbeschreibung <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editNewsItem()">Änderungen speichern </button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

</div>